import { defineStore } from 'pinia'
import type { BlueBoxTextType } from '@/app/types'


export interface UiState {
  showTimeKeeper: boolean,
  showTrainingLayout: boolean,
  isTraining: boolean,
  blueBoxTextType: BlueBoxTextType,
  showWind: boolean,
  showTrail: boolean,
  trailX: number,
  trailY: number
}

const initialState = (): UiState => ({
  showTimeKeeper: false,
  showTrainingLayout: false,
  isTraining: false,
  blueBoxTextType: -1,
  showWind: false,
  showTrail: false,
  trailX: 0,
  trailY: 0
})

export const uiState = defineStore('uiState', {
  state: initialState
})
